import { useEffect, useState } from 'react';
import analytics from '../../analytics';
import Card from '../../components/Card/MainCard';
import StepBar from '../../components/StepBar';
import Button from '../../components/Button';
import Langs from '../../assets/langs/main';
import { LangsType } from '../../types';
const REDIRECT_URL = 'REACT_APP_REDIRECT_URL';

export default function App() {
  const [lang, setLang] = useState<LangsType>('en');
  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    const TG = window?.Telegram?.WebApp;

    if (TG) {
      TG?.expand();
      TG?.enableClosingConfirmation();
    }

    const USER_DATA = TG?.initDataUnsafe?.user;
    const USER_LANGUAGE = USER_DATA?.language_code;

    if (TG && USER_LANGUAGE) {
      if (
        USER_LANGUAGE === 'en' ||
        USER_LANGUAGE === 'es' ||
        USER_LANGUAGE === 'ms' ||
        USER_LANGUAGE === 'pt-br'
      ) {
        setLang(USER_LANGUAGE);
      } else {
        setLang('en');
      }
    }

    if (TG && USER_DATA?.id) {
      analytics.identify({ userId: USER_DATA?.id });
    };
    analytics.track('open_app');

    const isOnboardingPassed = localStorage.getItem(
      'isOnboardingPassed',
    ) as string;

    if (isOnboardingPassed) {
      setTimeout(() => {
        followLink(USER_LANGUAGE);
      }, 1000);
      return;
    }

    setTimeout(() => {
      analytics.track('onboarding_start');
      setStep(1);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const followLink = (locale: LangsType) => {
    window.location.assign(`${REDIRECT_URL}`);
  };

  const THIRD_SECTION_DATA = [
    {
      title: Langs[lang].sign_up,
      subtitle: Langs['en'].open_account,
      imageSrc: '/images/icons/ThirdCard_First.png',
    },
    {
      title: Langs[lang].practice,
      subtitle: Langs['en'].get_skills,
      imageSrc: '/images/icons/ThirdCard_Second.png',
    },
    {
      title: Langs[lang].deposit_trade,
      subtitle: Langs['en'].over_instruments,
      imageSrc: '/images/icons/ThirdCard_Third.png',
    },
  ];

  const handleBtnClick = () => {
    if (step === 3) {
      localStorage.setItem('isOnboardingPassed', 'true');
      followLink(lang);
    } else {
      setStep(step + 1);
    }
  };

  return (
    <div className='relative flex flex-col items-center justify-between w-full h-full text-white bg-[#212A40]'>
      <div className='w-full flex flex-col items-center justify-center gap-5'>
        <h1 className='w-full py-3 font-semibold text-[17px] text-center'>
          Expert Option
        </h1>
        {step === 1 && (
          <div className='mt-2 relative w-full h-full flex flex-col items-center justify-center max-w-[320px] text-center gap-2'>
            <h2 className='font-bold text-center text-2xl z-2 w-[185px]'>
              Investing is Even Better Now
            </h2>
            <p className='z-20 text-center text-[15px] text-white w-[310px]'>
              Providing you the opportunity to invest in more than 100 assets
              for continuous income
            </p>
          </div>
        )}
        {step === 2 && (
          <div className='mt-2 relative w-full h-full flex flex-col items-center justify-center max-w-[300px] text-center gap-2'>
            <h2 className='font-bold text-2xl z-[30]'>
              {Langs['en'].user_testimonials}
            </h2>
            <p className='z-20 text-center text-[15px] text-white'>
              {Langs['en'].join_quotex}
            </p>
          </div>
        )}
      </div>

      {step === 0 && (
        <div className='mt-[-10vh] flex items-center justify-center h-full w-full'>
          <img src='/logo.svg' alt='logotype' width={195} height={35} />
        </div>
      )}

      {step === 1 && (
        <div className='w-full flex flex-col items-center justify-center max-w-[300px] text-cente gap-5'>
          <img
            src={`/images/png/en/1.png`}
            alt='First'
            width={300}
            height={450}
          />
        </div>
      )}

      {step === 2 && (
        <div className='relative w-full h-full flex flex-col items-center justify-center text-center gap-10'>
          <img
            src={`/images/png/en/2.png`}
            alt='Second'
            width={300}
            height={450}
          />
          <img
            src={`/images/png/en/2-another.png`}
            alt='Second part'
            className='absolute top-[40%]'
            width={291}
            height={136}
          />
        </div>
      )}

      {step === 3 && (
        <div className='px-5 mt-5 w-full h-full flex flex-col items-center justify-start gap-[32px]'>
          {THIRD_SECTION_DATA.map((data, index) => {
            return (
              <Card title={data.title} subtitle={data.subtitle} index={index} />
            );
          })}
        </div>
      )}

      {step > 0 && (
        <div
          className='fixed bottom-0 flex flex-col items-center justify-center w-full z-10 pb-5'
          style={{
            background:
              'linear-gradient(0deg, #212A40 0%, #212A40 75.55%, rgba(16, 44, 82, 0) 96.71%)',
          }}
        >
          <StepBar active={step} />
          <Button title={Langs[lang].continue} onClick={handleBtnClick} />
        </div>
      )}
    </div>
  );
}
